import React, { useState } from 'react'
import { Image, Button, Badge, Spin } from 'antd'

// Image
import bellIcon from '../../assets/bell-icon.svg'
// import circaImage from '../../assets/teams/circa_sports_trout.png'
import logo from '../../assets/hockey-logo.png'
import { useSelector } from 'react-redux'
import { BiRightArrowAlt } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom'
// import RoutesButton from '../RoutesButton'
import { leagueSalaryCap } from '../../config/constants'
// import Loader from '../Loader'

const Header = () => {
  const USER = useSelector((state) => state.user)
  const user = useSelector((state) => state.user.userDetails)
  const leagueType = user?.team?.currentLeague?.leagueType
  const teamSalary = useSelector((state) => state.user.teamSalaryCap)
  const { auctionCount } = useSelector((state) => state.user)
  const navigate = useNavigate()

  const teamFinancials = () => {
    navigate('/team-financials')
  }

  return user && user?.team ? (
    <header className='hockey-header'>
      <div className='left' style={{ width: leagueType === 'professional' ? '170px' : '220px' }}>
        <div className='image_div'>
          <Image preview={false} src={user?.team.logo} />
        </div>
        <p style={{ cursor: 'pointer' }} onClick={() => navigate('/league-notification')}>
          <span style={{ color: !!USER?.notificationCount ? 'red' : ' var(--lightGrayText)' }}>
            League Notification
          </span>{' '}
          {USER?.notificationCount > 0 ? (
            <Badge count={USER?.notificationCount}>
              <img src={bellIcon} alt='Icon' />
            </Badge>
          ) : (
            <img src={bellIcon} alt='Icon' />
          )}
        </p>
      </div>
      <div className='center'>
        <div className='center_left' style={{ flex: leagueType === 'professional' ? 1 : 2 }}>
          <div className='title_box'>
            <h1>{user?.team?.name}</h1>
            <p onClick={() => navigate('/player-auction')}>
              <span>Live Player Auction</span>{' '}
              {/* {auctionCount ? (
                  <Badge count={auctionCount}>
                    <img src={bellIcon} alt='Icon' />
                  </Badge>
                ) : (
                  <img src={bellIcon} alt='Icon' />
                )} */}
              <Badge count={auctionCount} color='#cdb51b'>
                <img src={bellIcon} alt='Icon' />
              </Badge>
            </p>
          </div>
          <div className='button_and_team_box'>
            <div className='button_box'>
              <Button style={{ flex: 1 }}>League Standings ({USER?.record?.overall})</Button>
              <Button style={{ flex: 1 }}>Division Standings ({USER?.record?.division})</Button>
            </div>
            <Button style={{ width: '100%' }}>Season Points ({USER?.record?.season})</Button>
          </div>
        </div>
        <div className='center_right'>
          <div className='team_financials_box'>
            <div style={{ cursor: 'pointer' }} onClick={teamFinancials}>
              <h4>Team Financials</h4>
              <h4>
                <BiRightArrowAlt size={18} />
              </h4>
            </div>
            <div>
              <p>League Salary Cap</p>
              {/* <span>$199,759,446</span> */}
              <span>{`$${leagueSalaryCap?.toLocaleString()}`}</span>
            </div>
            <div>
              <p>Team Salary Cap</p>
              <span>{`$${teamSalary ? teamSalary?.toLocaleString() : '-'}`}</span>
            </div>
            <div>
              <p>Team Cap Left</p>
              <span>{`$${(leagueSalaryCap - teamSalary ? teamSalary : 0)?.toLocaleString()}`}</span>
            </div>
          </div>
        </div>
      </div>
      {leagueType === 'professional' && (
        <div className='right'>
          <div className='content'>
            <div className='top'>
              <span style={{ width: '100%', textAlign: 'right' }}>
                <span>23&apos;</span> &nbsp;
                <span>SAMS 1,491,526</span>
              </span>
            </div>
            <div className='content2'>
              <div className='image_div'>
                <Image preview={false} src={logo} alt='UFAFL' />
              </div>
              <div className='content3'>
                <div className='top' style={{ marginBottom: '12px' }}>
                  <span>24&apos;</span>
                  <p>SHL Prize-Pool</p>
                </div>
                <div className='top'>
                  <span>25&apos;</span>
                  <p>SHL Prize-Pool</p>
                </div>
              </div>
            </div>
          </div>
          <h1>SHL Prize_Pools</h1>
        </div>
      )}
    </header>
  ) : (
    <div className='empty_header'>
      <Spin />
    </div>
  )
}

export default Header
